module.exports = __webpack_public_path__ + "static/slider-1-6f8206c1518e9965f28e5e5bae563121.png";